import React from "react";
import {PublisherBookModel} from "../../../models/publisher/publisher-book.model";
import {Grid} from "@material-ui/core";
import {StyledButton} from "../../ui-base/button";
import Lightbox from "react-image-lightbox";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {Colors} from "../../../theme/colors";
import {BookCover} from "../../shared/book-cover";
import {CustomBookMapIcon} from "../../ui-base/icons/custom-book-map-icon";
import {AuthMeModel} from "../../../models/auth-me.model";
import {RootState} from "../../../store/root-reducer";
import { useSelector } from "react-redux";

export const PublisherLeftBookDetails: React.FC<{ book: PublisherBookModel }> = ({book}) => {
    const [openCoverLightbox, setOpenCoverLightbox] = React.useState<boolean>(false);
    const {t} = useTranslation(['author', 'common', 'publisher']);

    const authMe: AuthMeModel = useSelector(
        (state: RootState) => state.auth.user
    );

    const getViewUrl = () => {

        const baseUrl = process.env.REACT_APP_API.replace('api/', '');
        return `${baseUrl}published-book/${book.id}/virtual-bookmap/start?language=${authMe.language}`;
    }

    return (
        <>
            <Grid item style={{position: 'relative', flex: 0, minWidth: '230px'}}>
                <BookCover
                    title={book?.original_title}
                    description={book?.description}
                    author={book.authors}
                />

                <Grid item container direction={"column"} spacing={2}>
                    {book.content_full?.file &&
                        <Grid item>
                            <a href={book.content_full.file} target="_blank" rel="noreferrer">
                                <StyledButton type={"button"}
                                              color={"transparentViolet"}>{t('leftManuscriptDetails.downloadManuscript')}</StyledButton>
                            </a>
                        </Grid>
                    }

                    {book.cover?.file &&
                        <Grid item>
                            <StyledDetailsHeader>{t('common:cover')}:</StyledDetailsHeader>
                            <img src={book.cover.file} onClick={() => setOpenCoverLightbox(true)}
                                 style={{cursor: 'pointer', marginTop: '0.5rem'}} alt={'Cover'}/>
                            {openCoverLightbox &&
                                <Lightbox mainSrc={book.cover.file} onCloseRequest={() => setOpenCoverLightbox(false)}/>
                            }
                        </Grid>
                    }

                    {book?.is_bookmap_ready &&
                        <StyledDownloadBookMapContainer item container direction={"row"}>
                            <a href={getViewUrl()} target="_blank" rel="noreferrer">
                                <Grid item container direction={"row"}>
                                    <Grid item>
                                        <CustomBookMapIcon style={{height: '49px', width: '49px', fill: 'none'}}/>
                                    </Grid>
                                    <Grid item style={{display: 'flex'}}>
                                        <StyledDownloadBookMap>{t('leftManuscriptDetails.showBookmap')}</StyledDownloadBookMap>
                                    </Grid>
                                </Grid>
                            </a>
                        </StyledDownloadBookMapContainer>
                    }

                    <StyledHr/>

                    <Grid item container direction={"column"}>
                        <Grid item>
                            <StyledDetailsSpan>{t('publisher:addBookNew.form.numberOfBooks')}:</StyledDetailsSpan>
                        </Grid>

                        <Grid item>
                            <StyledDetailsP>{book.saledata?.copies || '---'}</StyledDetailsP>
                        </Grid>
                    </Grid>

                    <Grid item container direction={"column"}>
                        <Grid item>
                            <StyledDetailsSpan>{t('publisher:addBookNew.form.releaseDate')}:</StyledDetailsSpan>
                        </Grid>

                        <Grid item>
                            <StyledDetailsP>{book.saledata?.publish_date || '---'}</StyledDetailsP>
                        </Grid>
                    </Grid>

                    <Grid item container direction={"column"}>
                        <Grid item>
                            <StyledDetailsSpan>{t('publisher:addBookNew.form.numberOfReleases')}:</StyledDetailsSpan>
                        </Grid>

                        <Grid item>
                            <StyledDetailsP>{book.saledata?.editions || '---'}</StyledDetailsP>
                        </Grid>
                    </Grid>

                    <Grid item container direction={"column"}>
                        <Grid item>
                            <StyledDetailsSpan>{t('publisher:addBookNew.form.numberOfSold')}</StyledDetailsSpan>
                        </Grid>

                        <Grid item>
                            <StyledDetailsP>{book.saledata?.sold_copies || '---'}</StyledDetailsP>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

const StyledDetailsHeader = styled('p')`
  color: ${Colors.violet};
  font-weight: 500;
`;

const StyledHr = styled('hr')`
  background-color: #E0E0E0;
  border: 0;
  height: 1px;
  width: 80%;
  margin: 1rem auto;
`;

const StyledDetailsSpan = styled('span')`
  color: ${Colors.grayText};
  font-weight: 400;
  font-size: 0.9rem;
`;

const StyledDetailsP = styled('p')`
  font-weight: 400;
  font-size: 0.9rem;
`;

const StyledDownloadBookMapContainer = styled(Grid)`
  cursor: pointer;
`;

const StyledDownloadBookMap = styled('p')`
  color: ${Colors.pink};
  padding: 0 5px;
  font-weight: 500;
  align-self: center;
`;
